module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Disagreeing Virtuously: Religious Conflict in Interdisciplinary Perspective")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/stylesheet.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "OT",
    attrs: {
      "id": "list"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/contents#list"
    }
  }, [_vm._v("List of Tables and Figures")])]), _vm._v(" "), _c('table', {
    staticClass: "table",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "id": "rt1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#t1"
    }
  }, [_vm._v("Table 1")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding-left": "1em"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#t1"
    }
  }, [_vm._v("Theological and philosophical reasons for disagreement and suggested cures")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "id": "rt2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#t2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Table 2")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding-left": "1em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#t2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Two types of cognitive processing")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "id": "rt3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#t3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Table 3")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding-left": "1em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#t3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("McGilchrist’s model of cognition: the master and the emissary")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "id": "rt4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#t4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Table 4")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding-left": "1em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#t4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psychological reasons for disagreement and suggested cures")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "id": "rfig1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#fig1"
    }
  }, [_vm._v("Figure 1")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding-left": "1em"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#fig1"
    }
  }, [_vm._v("Disagreement and various types of inquiry")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "id": "rfig2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#fig2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 2")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding-left": "1em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#fig2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stanovich’s model of the dual-process account")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "id": "rfig3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#fig3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 3")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding-left": "1em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#fig3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Haidt’s three ways of ethical deliberation")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "id": "rfig4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#fig4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 4")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding-left": "1em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#fig4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The process of debiasing")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "id": "rfig5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#fig5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 5")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding-left": "1em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#fig5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bootstrapping")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e183708","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/list.vue
// module id = 66
// module chunks = 0